// eslint-disable-next-line import/prefer-default-export
export const ACCOUNT_STATUS_LABEL = Object.freeze({
  payment_issue: 'Payment Issue',
  on_review: 'On Review',
  restricted: 'Restricted',
  replacement: 'Replacement',
  solved: 'Solved',
})
